import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import Dropdown from "react-bootstrap/Dropdown";
import { logout } from "../../../services/AuthService";
import { isNullOrEmpty } from "../../../config/ENV";
import { JobService } from "../../../services/JobService";
import { Link, useHistory } from "react-router-dom";
import Linkify from "react-linkify";
import { Col, Row } from "reactstrap";
import { showLocalDateTime } from "../../../utilities/timeutility";
const Header = () => {
  let count = 0;
  const history = useHistory();
  const [show, setshow] = useState(false);
  const [notification, setNotification] = useState([]);
  const [event, setNewEvent] = useState("");

  useEffect(() => {
    let jobId = window.localStorage.getItem("requestId");
    if (jobId !== "") {
      getNotification();
    }
  }, [count]);

  const getNotification = () => {
    const jobId = window.localStorage.getItem("requestId");
    JobService.getNotificationService(jobId).then((response) => {
      if (response.status === 200) {
        // setNotesList(response.data.notes);
        setNewEvent(response.data.newEvents);
        setNotification(response.data.notifications);
      }
    });
  };

  const Notificationcom = () => {
    history.push("/notifications");
  };
  const navigateTo = (id) => {
    // window.localStorage.setItem("notificationId", id);

    history.push("/notifications");
  };

  const UpdateNotification = (id) => {
    JobService.updateNotification(id).then((response) => {
      try {
        let notification = response.data;

        if (notification !== null) {
          getNotification();
        }
      } catch (error) {
        console.log("readNotification" + JSON.stringify(error));
      }
    });
  };

  const readNotification = (notification) => {
    window.localStorage.setItem("requestId", notification.contextId);

    UpdateNotification(notification.id);
    
    getNotification();
    setTimeout(() => {
      window.location.reload();
    },);
  };

  const logouthandler = () => {
    setshow((prev) => !prev);
  };

  useEffect(() => {}, [count]);

  const handleLogout = () => {
    logout()
      .then((response) => {
        try {
          firebase
            .auth()
            .signOut()
            .then(function () {
              window.localStorage.removeItem("user");
              window.localStorage.removeItem("account");
              window.localStorage.clear();
              sessionStorage.clear();
              window.location.href = "/";
            })
            .catch(function () {
              window.localStorage.clear();
              sessionStorage.clear();
              window.location.href = "/";
            });
        } catch (err) {
          window.localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        }
      })
      .catch((error) => {
        firebase
          .auth()
          .signOut()
          .then(function () {
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("account");
            window.localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
          })
          .catch(function () {
            window.localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
          });
      });
  };


  return (
    <>
      <div className="container">
        <div className=" min-sm:ml-9 w-50 top-[24px] text-white fixed max-sm:absolute z-30 max-sm:ml-6">
          <a className="loginheader">
            {window.localStorage.getItem("employerName")}
          </a>
        </div>

        <header className="bg-gradient-to-br from-primary-blue3 to-primary-blue min-sm:fixed top-0 w-screen max-sm:h-1/2 max-sm:-z-10 min-sm:z-0 min-sm:h-16 shadow-primary-gray head_nav_z t-card-widt-card-wid">
          <div className="header-wrapper ">
            <div className="  headerWelcome min-sm:fixed z-20 min-sm:right-[54px] min-sm:top-5 flex flex-col min-sm:flex-row-reverse min-sm:items-center max-sm:absolute max-sm:top-12 max-sm:header-left-text max-sm:pt-8 max-sm:px-6 text-primary-white font-assistant t-primary-blue t-top-head">
              <div
                id="nav-toggle"
                className="group  min-sm:hover:h-screen min-sm:hover:pl-[240px] cursor-pointer max-sm:drop-shadow-3xl hover:drop-shadow-sm transition-all ease-in-out t-person-icon-top"
              >
                <svg
                  id="toggle-icon"
                  className="hover:scale-110 transition-all ease-in-out mt-1 "
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="#FFFFFF"
                    d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                  ></path>
                </svg>

                {!isNullOrEmpty(event) && (
                  <>
                    <div className="notifi_bell bg-danger rounded-full bg-[#FF0000] absolute top-0 right-0">
                      {event}
                    </div>
                  </>
                )}

                {/* <div className="w-2 h-2 rounded-full bg-red bg-[#FF0000] absolute top-0 right-0"></div> */}

                <nav className=" t-fixed hidden group-hover:block dropdown absolute min-sm:right-0 min-sm:top-11 z-10 max-sm:shadow-outer max-sm:left-0 transition ease-in-out">
                  <div className=" bg-white shadow-sm text-primary-dark w-56 text-sm w-[350]">
                    <ul className="">
                      {" "}
                      <li className=" py-2  menuItem">
                        <ul className="bg-primary-white p-7 ">
                          {notification.length > 0 &&
                            notification.slice(0, 5).map((item,index) => (
                              <div key={index}>
                                {item.status.value !== "Read" ? (
                                  <>
                                    <Link
                                      onClick={() => readNotification(item)}
                                      className="text-dark "
                                      to={
                                        item.type.key == "JOBREQ_NOTES"
                                          ? `/addrequest/${item.contextId}?t=notes`
                                          : `/viewcandidatedetails/${item.contextId2}/${item.contextId}`
                                      }
                                    >
                                      <Row className="pl-3 pb-3">
                                        <Col className="col-6  center ">
                                          {item.senderName}
                                        </Col>

                                        <Col className="col-6">
                                          {" "}
                                          <Col >
                                            <div className="font-semibold  t-font-size-notification flex t-justify-content-end  pb-1 basis-[10%] t-basis-date justify-end">
                                              {showLocalDateTime(
                                                item.createdOn
                                              )}
                                            </div>
                                          </Col>{" "}
                                          </Col>
                                          </Row>
                                          <Col className=" center pl-3" >
                                         
                                          <li
                                            className=""
                                            key={item.id}
                                            onClick={(e) => navigateTo(item.id)}
                                          >
                                            <Linkify className="p-0">
                                              {" "}
                                              <strong>
                                                {" "}
                                                {item.description}
                                              </strong>
                                            </Linkify>
                                            <span href={item.link} target="_blank">
                                              {item.link}
                                            </span>
                                          </li>
                                        </Col>
                                      
                                    </Link>
                                  </>
                                ) : (
                                  <>
                                    <Link
                                      onClick={() => readNotification(item)}
                                      className="text-dark"
                                      to={
                                        item.type.key == "JOBREQ_NOTES"
                                          ? `/addrequest/${item.contextId}?t=notes`
                                          : `/viewcandidatedetails/${item.contextId2}/${item.contextId}`
                                      }
                                    >
                                      <Row className="pl-3 pb-3">
                                        <Col className=" col-6 center ">{item.senderName}</Col>
                                      
                                          <Col className="col-6">
                                            <Col> <div className=" t-font-size-notification flex t-justify-content-end pb-1 basis-[10%] t-basis-date justify-end">
                                              {showLocalDateTime(
                                                item.createdOn
                                              )}
                                            </div></Col>
                                           
                                          </Col></Row>


                                          <Row className="pl-3 pb-3"><Col>
                                          <li
                                            className=" text-muted pr-3"
                                            key={item.id}
                                          >
                                            <Linkify className="p-0">
                                              {item.description}
                                            </Linkify>
                                            <span href={item.link} target="_blank">
                                              {item.link}
                                            </span>
                                          </li>{" "}
                                        </Col>
                                      </Row>
                                    </Link>
                                  </>
                                )}

                                <hr  className="my-3"/>
                              </div>
                            ))}
                          {notification.length > 0 ? (
                            <>
                              <li>
                                <span onClick={Notificationcom}>
                                  <a className="p-4">
                                    {" "}
                                    Show All Notifications{" "}
                                  </a>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                  >
                                    <path d="M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z" />
                                  </svg>
                                </span>
                              </li>
                            </>
                          ) : (
                            <> <a className="p-4 flex t-nodata text-muted">
                            {" "}
                           No notifications  {" "}
                          </a>
                            </>
                          )}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </nav>

                {/* <svg
                  width="28"
                  height="28"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.25 23.4C7.25 23.8142 7.58579 24.15 8 24.15C8.41421 24.15 8.75 23.8142 8.75 23.4H7.25ZM21.25 23.4C21.25 23.8142 21.5858 24.15 22 24.15C22.4142 24.15 22.75 23.8142 22.75 23.4H21.25ZM7.25 22V23.4H8.75V22H7.25ZM22.75 23.4V22H21.25V23.4H22.75ZM22.75 22C22.75 17.7198 19.2802 14.25 15 14.25V15.75C18.4518 15.75 21.25 18.5482 21.25 22H22.75ZM8.75 22C8.75 18.5482 11.5482 15.75 15 15.75V14.25C10.7198 14.25 7.25 17.7198 7.25 22H8.75ZM18.45 10.8C18.45 12.7054 16.9054 14.25 15 14.25V15.75C17.7338 15.75 19.95 13.5338 19.95 10.8H18.45ZM15 14.25C13.0946 14.25 11.55 12.7054 11.55 10.8H10.05C10.05 13.5338 12.2662 15.75 15 15.75V14.25ZM11.55 10.8C11.55 8.89462 13.0946 7.35 15 7.35V5.85C12.2662 5.85 10.05 8.06619 10.05 10.8H11.55ZM15 7.35C16.9054 7.35 18.45 8.89462 18.45 10.8H19.95C19.95 8.06619 17.7338 5.85 15 5.85V7.35ZM28.25 15C28.25 22.3178 22.3178 28.25 15 28.25V29.75C23.1462 29.75 29.75 23.1462 29.75 15H28.25ZM15 28.25C7.68223 28.25 1.75 22.3178 1.75 15H0.25C0.25 23.1462 6.8538 29.75 15 29.75V28.25ZM1.75 15C1.75 7.68223 7.68223 1.75 15 1.75V0.25C6.8538 0.25 0.25 6.8538 0.25 15H1.75ZM15 1.75C22.3178 1.75 28.25 7.68223 28.25 15H29.75C29.75 6.8538 23.1462 0.25 15 0.25V1.75Z"
                    fill="white"
                  />
                </svg>

                <nav className=" t-fixed hidden group-hover:block dropdown absolute min-sm:right-0 min-sm:top-11 z-10 max-sm:shadow-outer max-sm:left-0 transition ease-in-out">
                  <div className=" bg-primary-white shadow-sm text-primary-dark w-56 text-sm">
                    <ul className="">
                      <a onClick={handleLogout} to={"/log"}>
                        {" "}
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem">
                          <span className="inline-block align-bottom w-4 h-5  ">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 23 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mr-4"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M14.467 6.90449C14.7355 6.636 15.1708 6.636 15.4393 6.90449L19.0486 10.5139C19.3171 10.7823 19.3171 11.2177 19.0486 11.4861L15.4393 15.0955C15.1708 15.364 14.7355 15.364 14.467 15.0955C14.1985 14.827 14.1985 14.3917 14.467 14.1232L17.5902 11L14.467 7.87676C14.1985 7.60828 14.1985 7.17297 14.467 6.90449Z"
                                fill="black"
                              ></path>
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.25 11C8.25 10.6203 8.5578 10.3125 8.9375 10.3125H18.5625C18.9422 10.3125 19.25 10.6203 19.25 11C19.25 11.3797 18.9422 11.6875 18.5625 11.6875H8.9375C8.5578 11.6875 8.25 11.3797 8.25 11Z"
                                fill="black"
                              ></path>
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M3.15273 3.15273C3.41059 2.89487 3.76033 2.75 4.125 2.75H8.9375C9.3172 2.75 9.625 3.0578 9.625 3.4375C9.625 3.8172 9.3172 4.125 8.9375 4.125L4.125 4.125L4.125 17.875H8.9375C9.3172 17.875 9.625 18.1828 9.625 18.5625C9.625 18.9422 9.3172 19.25 8.9375 19.25H4.125C3.76033 19.25 3.41059 19.1051 3.15273 18.8473C2.89487 18.5894 2.75 18.2397 2.75 17.875V4.125C2.75 3.76033 2.89487 3.41059 3.15273 3.15273Z"
                                fill="black"
                              ></path>
                            </svg>
                          </span>
                          Log out
                        </li>{" "}
                      </a>
                    </ul>
                  </div>
                </nav> */}
              </div>

              <h1 className=" min-sm:fixed min-sm:right-[90px] min-sm:top-[22px] max-sm:text-2xl font-semibold z_morning">
                {" "}
                <div className="userlogin mt-1 ">
                  {" "}
                  {window.localStorage.getItem("name")}{" "}
                  {!isNullOrEmpty(window.localStorage.getItem("lastName"))}
                </div>
              </h1>
            </div>
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;